import React from 'react';
import { BarChart3, Users, Building2, Activity } from 'lucide-react';
import { useAgencies } from '../../hooks/useAgencies';
import { useUsers } from '../../hooks/useUsers';
import { StatsOverview } from './stats/StatsOverview';
import { AgencyActivityChart } from './stats/AgencyActivityChart';
import { UserActivityChart } from './stats/UserActivityChart';

export const AdminStats: React.FC = () => {
  const { agencies } = useAgencies();
  const { users } = useUsers();

  const activeAgencies = agencies.filter(a => a.status === 'active').length;
  const suspendedAgencies = agencies.filter(a => a.status === 'suspended').length;
  const activeUsers = users.filter(u => u.status === 'active').length;
  const suspendedUsers = users.filter(u => u.status === 'suspended').length;

  return (
    <section className="space-y-6">
      <div className="flex items-center gap-3">
        <BarChart3 className="h-6 w-6 text-primary-500" />
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          Vue d'ensemble
        </h2>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <StatsOverview
          title="Agences actives"
          value={activeAgencies}
          icon={Building2}
          trend={{
            value: '+12%',
            direction: 'up',
          }}
        />
        <StatsOverview
          title="Agences suspendues"
          value={suspendedAgencies}
          icon={Building2}
          trend={{
            value: '-5%',
            direction: 'down',
          }}
        />
        <StatsOverview
          title="Utilisateurs actifs"
          value={activeUsers}
          icon={Users}
          trend={{
            value: '+8%',
            direction: 'up',
          }}
        />
        <StatsOverview
          title="Utilisateurs suspendus"
          value={suspendedUsers}
          icon={Users}
          trend={{
            value: '-2%',
            direction: 'down',
          }}
        />
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              Activité des agences
            </h3>
            <Activity className="h-5 w-5 text-primary-500" />
          </div>
          <AgencyActivityChart />
        </div>

        <div className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              Activité des utilisateurs
            </h3>
            <Activity className="h-5 w-5 text-primary-500" />
          </div>
          <UserActivityChart />
        </div>
      </div>
    </section>
  );
};